// extracted by mini-css-extract-plugin
export default {"container":"Braintree_container__l7rpJ","visible":"Braintree_visible__Hw2kD","close":"Braintree_close__W+Rfm"};